<template>
  <transition enter-active-class='animated animated3 fadeInDown' leave-active-class='animated animated3 fadeOutUp'>
    <div class="alert message-wrap" :class='{alertClass:true}' role="alert" v-if="visible">
      <span><i class="iconfont" :class="alertIcon"></i> {{content}}</span>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    content: {
      type: String,
      default: '默认信息xxxxxxxx',
    },
    type: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    alertClass() {
      return `alert-${this.type}`;
    },
    alertIcon() {
      switch (this.type) {
        case 'success':
          // eslint-disable-next-line no-unreachable
          return 'icon-duigouxiao'; break;
        case 'info':
          // eslint-disable-next-line no-unreachable
          return 'icon-duigouxiao'; break;
        case 'warning':
          // eslint-disable-next-line no-unreachable
          return 'icon-jinggao'; break;
        case 'danger':
          // eslint-disable-next-line no-unreachable
          return 'icon-cuowu'; break;
        default:
          return '未知操作';
      }
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    startTimer() {
      window.setTimeout(() => {
        this.visible = false;
      }, 3000);
    },
  },
  mounted() {
    this.startTimer();
  },
};

</script>

<style scoped lang='less'>
  .message-wrap {
    position: fixed;
    margin:auto;
    left:0;
    right:0;
    display: inline-block;
    top: 25px;
    z-index: 999;
    text-align:center;
    width:220px;
    letter-spacing:2px;
    padding: 16px 24px;
    border: 0;
    background: #FFFFFF;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 6px 6px;
  }
  .animated1 {
      animation-duration: 0.1s;
      animation-fill-mode: both;
  }
  .animated2 {
      animation-duration: 0.2s;
      animation-fill-mode: both;
  }
  .animated3 {
      animation-duration: 0.3s;
      animation-fill-mode: both;
  }
  i.icon-duigouxiao{
    color: #28A745;
  }
  i.icon-jinggao{
    color: #FFC107;
  }
  i.icon-cuowu{
    color: #DC3545;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/message/index.vue